import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { Button } from "@mui/material";
import Home from "./pages/Home";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
